import ReactGA from "react-ga4";

export function initGA() {
  ReactGA.initialize(process.env['REACT_APP_G_ANALYTICS_ID'] as string);
}